export enum ConnectionState {
  Connected = 'connected',
  Reconnecting = 'reconnecting',
  Disconnected = 'disconnected'
}
